let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l1UOm")).then(() => parcelRequire('aYffm'));